import React from 'react';
import AvailabilityHeadingHotel from "./AvailabilityHeadingHotel";
import AvailabilityTable from "../containers/AvailabilityTable";
import LinearProgress from 'material-ui/LinearProgress';
import {AvailabilityTableMobile} from "../containers/AvailabilityTable";

const AvailabilityPropertyComponent = ({property, processing, isMobile}) => {

  let displayAvailabilityTable = property.availability !== undefined
      && property.availability.properties.length > 0;
    return (
        <div>
          {
            displayAvailabilityTable &&
            <div>
              <AvailabilityHeadingHotel
                  property={property.availability.properties[0]}/>
              {!isMobile && <AvailabilityTable
                  property={property.availability.properties[0]}
                  criteria={property.availability.availabilityRequest}
                />
              }
              {isMobile && <AvailabilityTableMobile
                  property={property.availability.properties[0]}
                  criteria={property.availability.availabilityRequest}
              />
              }
            </div>
          }
          {processing && <LinearProgress className="availabilitySearchProgress"
                                         mode="indeterminate"/>}
          {!processing && !displayAvailabilityTable &&
            <div className="error">
              <p>{property.message}</p>
            </div>
          }
        </div>
    )
};

export default AvailabilityPropertyComponent;


// WEBPACK FOOTER //
// ./src/components/AvailabilityPropertyComponent.js